import { jsx as _jsx } from "react/jsx-runtime";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneIcon from "@mui/icons-material/Done";
import { IconButton, styled, Tooltip } from "@mui/material";
import { useState } from "react";
import { copyToClipboard } from "../utils";
const CopyButton = styled(IconButton)({
    padding: 0
});
export const CopyableText = (props)=>{
    const [copied, setCopied] = useState(false);
    const copy = ()=>{
        copyToClipboard(props.value);
        setCopied(true);
        setTimeout(()=>setCopied(false), 1500);
    };
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: copied ? 'Copied!' : props.tooltip ?? props.value,
        children: /*#__PURE__*/ _jsx(CopyButton, {
            onClick: copy,
            size: "small",
            children: copied ? /*#__PURE__*/ _jsx(DoneIcon, {
                color: "success"
            }) : /*#__PURE__*/ _jsx(ContentCopyIcon, {})
        })
    });
};
CopyableText.displayName = 'CopyableText';

//# sourceMappingURL=CopyableText.js.map